




























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class PosterAiFamily extends Vue {
  @Prop({ default: false, type: Boolean }) visible!: boolean;
  envStr: string = '';
  envUrl: string = '';
  mounted() {
    this.getEnv();
  }
  getEnv() {
    window.TDAPP.onEvent('小麦秀-点击引流广告位', 'H5');
    console.log(process.env.VUE_APP_DEPLOY_ENV, 'env++++++++++++++++++++++');
    this.envStr = process.env.VUE_APP_DEPLOY_ENV || '';
    let envs = process.env.VUE_APP_DEPLOY_ENV;
    if (envs == undefined || envs == 'dev' || envs == 'rc' || envs == '') {
      this.envUrl = 'https://image.xiaomaiketang.com/xm/internal/DhsRRSNiCC.jpg';
    } else if (envs == 'gray' || envs == 'prod') {
      this.envUrl = 'https://image.xiaomaiketang.com/xm/internal/WmtzQQZnNd.jpg';
    } else {
      this.envUrl = 'https://image.xiaomaiketang.com/xm/internal/nNMxDkwCSY.jpg';
    }
  }
  handleClose() {
    this.$emit('onClose');
  }
}
